import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from "@angular/material/dialog";
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmacacao-inclusao-cartao',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './confirmacacao-inclusao-cartao.component.html',
  styleUrls: ['./confirmacacao-inclusao-cartao.component.css']
})
export class ConfirmacacaoInclusaoCartaoComponent {
  public constructor(
    @Inject(MAT_DIALOG_DATA) public valorPagar: number,
  ) {
  }
}
